<div
    *ngIf="venueNotInService"
>
    <app-venue-not-in-service></app-venue-not-in-service>
</div>
<div
    *ngIf="!venueNotInService && !availability"
    class="hstack justify-content-center"
    style="min-height: 180px;"
>
    <div class="spinner-border" role="status"></div>
</div>
<form
    *ngIf="!venueNotInService && availability"
    class="form-group vstack gap-3 h-100"
    appVenueColour
    [primaryColour]="availability.venue.primaryColour"
>
    <ng-container
        *ngIf="form.get('step')?.value !== ModifyBookingStep.SelectTableAndDate"
    >
        <ng-container
            *ngTemplateOutlet="summary; context: { availability: availability }"
        >
        </ng-container>
    </ng-container>
    <ng-container
        [ngSwitch]="form.get('step')?.value"
    >
        <ng-container
            *ngSwitchCase="ModifyBookingStep.SelectTableAndDate"
        >
            <ng-container
                *ngTemplateOutlet="selectPartySizeAndDate; context:  {
                    availability: availability,
                }"
            >
            </ng-container>
        </ng-container>
        <ng-container
            *ngSwitchCase="ModifyBookingStep.SelectRestrictions"
        >
            <ng-container
                *ngTemplateOutlet="selectRestrictions"
            >
            </ng-container>
        </ng-container>
        <ng-container
            *ngSwitchCase="ModifyBookingStep.SelectBookingType"
        >
            <ng-container
                *ngTemplateOutlet="selectBookingType; context: {
                    availability: availability,
                }"
            >
            </ng-container>
        </ng-container>
        <ng-container
            *ngSwitchCase="ModifyBookingStep.ExplainNonReservableEventBooking"
        >
            <ng-container
                *ngTemplateOutlet="explainNonReservableEventBooking; context: {
                    availability: availability,
                }"
            >
            </ng-container>
        </ng-container>
        <ng-container
            *ngSwitchCase="ModifyBookingStep.SelectReason"
        >
            <ng-container
                *ngTemplateOutlet="selectReason; context: {
                    availability: availability,
                }"
            >
            </ng-container>
        </ng-container>
        <ng-container
            *ngSwitchCase="ModifyBookingStep.SelectDuration"
        >
            <ng-container
                *ngTemplateOutlet="selectDuration; context: {
                    availability: availability,
                }"
            >
            </ng-container>
        </ng-container>
        <ng-container
            *ngSwitchCase="ModifyBookingStep.SelectArea"
        >
            <ng-container
                *ngTemplateOutlet="selectArea; context: {
                    availability: availability,
                }"
            >
            </ng-container>
        </ng-container>
        <ng-container
            *ngSwitchCase="ModifyBookingStep.SelectTime"
        >
            <ng-container
                *ngIf="!canSelectTimeOptions(availability)"
            >
                <app-no-availability
                    [availability]="availability"
                    [requiresDogFriendly]="form.get('requiresDogFriendly')?.value"
                    [requiresWheelchairAccess]="form.get('requiresWheelchairAccess')?.value"
                    [requiresPramAccessible]="form.get('requiresPramAccessible')?.value"
                    [requiresHighchairFriendly]="form.get('requiresHighchairFriendly')?.value"
                    [idealTime]="form.get('idealTime')?.value"
                    [partySize]="form.get('partySize')?.value"
                    [areaId]="form.get('selectedAreaId')?.value"
                    [eventId]="form.get('selectedEventId')?.value"
                    [reasonId]="form.get('selectedReasonId')?.value"
                    (joinWaitlistRequested)="joinWaitlistStep()"
                >
                </app-no-availability>
            </ng-container>
            <ng-container
                *ngIf="canSelectTimeOptions(availability)"
            >
                <ng-container
                    *ngTemplateOutlet="selectTime; context: {
                        areaId: form.get('selectedAreaId')!.value,
                        reasonId: form.get('selectedReasonId')!.value,
                        eventId: form.get('selectedEventId')!.value,
                        partySize: form.get('partySize')!.value,
                        idealTime: form.get('idealTime')!.value,
                        availability: availability,
                        useAnyReasonAvailability: isDurationReasonMode(availability),
                    }"
                >
                </ng-container>
            </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="ModifyBookingStep.JoinWaitlist">
            <app-waitlist-form
                [availability]="availability"
                [requiresDogFriendly]="form.get('requiresDogFriendly')?.value"
                [requiresWheelchairAccess]="form.get('requiresWheelchairAccess')?.value"
                [requiresPramAccessible]="form.get('requiresPramAccessible')?.value"
                [requiresHighchairFriendly]="form.get('requiresHighchairFriendly')?.value"
                [partySize]="form.get('partySize')?.value"
                [eventId]="form.get('selectedEventId')?.value"
                [reasonId]="form.get('selectedReasonId')?.value"
                [date]="formDate"
                [idealTime]="formIdealTime"
                [organisationId]="organisationId"
                [businessId]="businessId"
                [venueId]="venueId"
            >
            </app-waitlist-form>
        </ng-container>
        <ng-container *ngSwitchCase="ModifyBookingStep.SelectOrder">
            <app-order-selection
                [partySize]="form.get('partySize')!.value"
                [availability]="availability"
                [selectedReasonId]="form.get('selectedReasonId')!.value"
                (orderConfirmed)="form.get('step')!.setValue(ModifyBookingStep.Summary)"
            ></app-order-selection>
        </ng-container>
    </ng-container>
    @if (form.valid) {
        <button
            *ngIf="!bookingDetails && form.get('step')?.value === ModifyBookingStep.Summary"
            class="btn btn-primary"
            type="button"
            data-testid="confirm-details"
            (click)="save(availability)"
        >
            Confirm & Continue
        </button>
        <button
            *ngIf="bookingDetails && form.get('step')?.value === ModifyBookingStep.Summary"
            class="btn btn-primary"
            type="button"
            [disabled]="!haveBookingDetailsChanged"
            (click)="save(availability)"
        >
            Confirm Changes
        </button>
    }
</form>

<ng-template
    #summary
    let-availability="availability"
>
    <div class="vstack gap-1 flex-grow-0">
        <div
            *ngIf="form.get('step')?.value !== ModifyBookingStep.SelectTableAndDate"
            class="btn btn-light px-3 py-2 rounded hstack gap-2 align-items-baseline"
            data-testid="booking-summary-table-for"
            (click)="selectTableAndDateStep()"
        >
            <label class="flex-shrink-0">
                Table for
            </label>
            <div
                class="hstack gap-1 justify-content-end flex-grow-1 flex-shrink-1 fw-semibold text-primary text-nowrap overflow-auto"
            >
                <span class="text-truncate">
                    {{ form.get('partySize')?.value | i18nPlural: partySizePluralMapping }}
                    ·
                    {{ form.get('date')?.value | ngbDate | date: 'mediumDate' }}
                </span>
                <img ngSrc="assets/pencil/normal.svg" width="24" height="24" />
            </div>
        </div>
        <div
            *ngIf="form.get('requiresWheelchairAccess')?.value !== null || form.get('requiresDogFriendly')?.value !== null || form.get('requiresPramAccessible')?.value !== null || form.get('requiresHighchairFriendly')?.value !== null"
            class="btn btn-light px-3 py-2 rounded hstack gap-2 align-items-baseline"
            (click)="selectRestrictionsStep()"
        >
            <label class="flex-shrink-0">
                Booking Requirements
            </label>
            <div
                class="hstack gap-1 justify-content-end flex-grow-1 flex-shrink-1 fw-semibold text-primary overflow-auto"
            >
                <span class="text-truncate">
                    @if (form.get('requiresWheelchairAccess')?.value) {
                        Wheelchair Access
                    }
                    @if (form.get('requiresDogFriendly')?.value) {
                        Dog Friendly
                    }
                    @if (form.get('requiresPramAccessible')?.value) {
                        Pram Accessible
                    }
                    @if (form.get('requiresHighchairFriendly')?.value) {
                        Highchair Friendly
                    }
                    @if (!form.get('requiresWheelchairAccess')?.value && !form.get('requiresDogFriendly')?.value && !form.get('requiresPramAccessible')?.value && !form.get('requiresHighchairFriendly')?.value) {
                        No Requirements
                    }
                </span>
                <img ngSrc="assets/pencil/normal.svg" width="24" height="24" />
            </div>
        </div>
        <div
            *ngIf="form.get('bookingType')?.value !== null && availability.availableEvents().length > 0"
            [class]="hideDateTimeControls ? 'px-3 py-2 rounded hstack gap-1 align-items-baseline bg-light' : 'btn btn-light px-3 py-2 rounded hstack gap-1 align-items-baseline'"
            [ngClass]="{ disabled: form.get('selectedEventId')?.disabled }"
            (click)="!hideDateTimeControls && selectBookingTypeStep()"
        >
            <label>
                Booking Type
            </label>
            <div
                class="hstack gap-2 justify-content-end flex-grow-1 fw-semibold text-primary"
            >
                <ng-container
                    *ngIf="form.get('bookingType')?.value === BookingType.Standard"
                >
                    Standard Booking
                </ng-container>
                <ng-container
                    *ngIf="form.get('bookingType')?.value === BookingType.Event"
                >
                    {{ form.get('selectedEventId')?.value | eventName : availability.venue }}
                </ng-container>
                <img *ngIf="!hideDateTimeControls" ngSrc="assets/pencil/normal.svg" width="24" height="24" />
            </div>
        </div>
        <div
            *ngIf="form.get('selectedReasonId')?.value !== null"
            class="btn btn-light px-3 py-2 rounded hstack gap-2 align-items-baseline"
            (click)="selectReasonOrDurationStep(availability)"
        >
            <span class="flex-shrink-0">
                {{ selectedReasonLabel(availability) }}
            </span>
            <div
                class="hstack gap-2 justify-content-end flex-grow-1 flex-shrink-1 fw-semibold text-primary overflow-auto"
            >
                <span class="text-truncate">
                    {{ form.get('selectedReasonId')?.value | reasonName : availability.venue }}
                </span>
                <img ngSrc="assets/pencil/normal.svg" width="24" height="24" />
            </div>
        </div>
        <div
            *ngIf="availability.areas.length > 1 && form.get('selectedAreaId')?.value !== null && (form.get('areaSelectionIsPossible')?.value || isDurationReasonMode(availability))"
            [class]="isDurationReasonMode(availability) ? 'px-3 py-2 rounded hstack gap-2 align-items-baseline bg-light' : 'btn btn-light px-3 py-2 rounded hstack gap-2 align-items-baseline'"
            (click)="!isDurationReasonMode(availability) && selectAreaStep()"
        >
            <label class="flex-shrink-0">
                Seating Area
            </label>
            <div
                class="hstack gap-2 justify-content-end flex-grow-1 flex-shrink-1 fw-semibold text-primary overflow-auto"
            >
                <span class="text-truncate">
                    {{ form.get('selectedAreaId')?.value | areaName : availability }}
                </span>
                <img *ngIf="!isDurationReasonMode(availability)" ngSrc="assets/pencil/normal.svg" width="24" height="24" />
            </div>
        </div>
        <div
            *ngIf="form.get('time')?.value !== null || (form.get('step')?.value === ModifyBookingStep.JoinWaitlist && form.get('idealTime')?.value !== null)"
            [class]="hideDateTimeControls ? 'px-3 py-2 rounded hstack gap-2 align-items-baseline bg-light' : 'btn btn-light px-3 py-2 rounded hstack gap-2 align-items-baseline'"
            (click)="!hideDateTimeControls && selectTimeStep()"
        >
            <label class="flex-shrink-0">
                Time
            </label>
            <div
                class="hstack gap-2 justify-content-end flex-grow-1 flex-shrink-1 fw-semibold text-primary overflow-auto"
            >
                <span class="text-truncate">
                    <ng-container *ngIf="form.get('time')?.value !== null; else waitlistRequestedTime">
                        {{ form.get('time')?.value | ngbTime | date: 'shortTime' }}
                        -
                        {{ form.get('endTime')?.value | ngbTime | date: 'shortTime' }}
                    </ng-container>
                    <ng-template #waitlistRequestedTime>
                        {{ form.get('idealTime')?.value | date: 'shortTime' }}
                    </ng-template>
                </span>
                <img *ngIf="!hideDateTimeControls" ngSrc="assets/pencil/normal.svg" width="24" height="24" />
            </div>
        </div>
        @let date = form.get('date')?.value | ngbDate;
        @if (date) {
            @if (availability.publicDiaryNoteOnDate(date); as publicDiaryNote) {
                <div
                    class="alert alert-info"
                    role="alert"
                >
                    <div class="hstack gap-3">
                        <div class="hstack gap-2">
                            <i class="bi bi-info-circle-fill text-info"></i>
                        </div>
                        <div class="hstack gap-2">
                            <span class="fw-semibold" [innerHTML]="publicDiaryNote">
                            </span>
                        </div>
                    </div>
                </div>
            }
        }
    </div>
</ng-template>

<ng-template
    #selectPartySizeAndDate
    [formGroup]="form"
    let-availability="availability"
>
    <ng-container>
        @if (!bookingDetails) {
            @if(!hidePinnedEvent && availability.venue.pinnedEvent(); as pinnedEvent) {
                <div class="vstack gap-2 rounded bg-light px-3 py-3 flex-grow-0">
                    <div class="hstack gap-2 justify-content-between">
                        <span class="badge bg-success-subtle text-success-emphasis lh-sm">
                            Event Available
                        </span>
                        @if (pinnedEvent.recurrence.startDates.length > 0 && pinnedEvent.recurrence.endDate) {
                            <span class="text-secondary fw-semibold small">
                                {{ pinnedEvent.recurrence.startDates[0] | date: 'mediumDate' }}
                                -
                                {{ pinnedEvent.recurrence.endDate | date: 'mediumDate' }}
                                <br/>
                            </span>
                        } @else if (pinnedEvent.recurrence.startDates.length > 0 && !pinnedEvent.recurrence.endDate) {
                            <span class="hstack gap-1 text-secondary fw-semibold small">
                                @for (startDate of pinnedEvent.recurrence.startDates; track startDate) {
                                    <span>
                                        {{ startDate | date: 'mediumDate'}}<span *ngIf="!$last">, </span>
                                    </span>
                                }
                            </span>
                        }
                    </div>
                    <ng-container
                        *ngTemplateOutlet="eventOption; context: {
                            event: pinnedEvent,
                            availability: availability,
                            canSelect: false,
                        }"
                    >
                    </ng-container>
                </div>
            }
        }
        <div class="vstack gap-2">
            @if (bookingDetails?.isDateRestricted === true) {
                <div
                    class="alert alert-info"
                    role="alert"
                >
                    <ng-container
                        *ngTemplateOutlet="dateRestrictedMessage"
                    >
                    </ng-container>
                </div>
            }
            <div class="position-relative">
                <div class="btn-group dropdown w-100">
                    <button
                        class="btn btn-outline-secondary dropdown-toggle hstack gap-2"
                        [disabled]="bookingDetails?.isDateRestricted ?? false"
                        (click)="partySizeSelect.click()"
                    >
                        <img
                            ngSrc="assets/people/normal.svg"
                            width="20"
                            height="20"
                            alt="party size"
                        >
                        <span
                            *ngIf="form.get('partySize')?.value === minLargePartySize"
                        >
                            @if (availability.venue.showLargerPartiesUnreservable) {
                                Larger parties unreservable
                            } @else {
                                {{ minLargePartySize | i18nPlural: partySizePluralMapping }} +
                            }
                        </span>
                        <span
                            *ngIf="form.get('partySize')?.value !== minLargePartySize"
                        >
                            {{ form.get('partySize')?.value | i18nPlural: partySizePluralMapping }}
                        </span>
                    </button>
                </div>
                <select
                    #partySizeSelect
                    class="form-select btn opacity-0 position-absolute top-0 start-0 w-100 h-100"
                    formControlName="partySize"
                    data-testid="party-size"
                >
                    <option
                        *ngFor="let size of availability.possiblePartySizes(formDate, restrictedReasonIds, preselectedEventId)"
                        [ngValue]="size"
                    >
                        {{ size | i18nPlural: partySizePluralMapping }}
                    </option>
                    <option
                        *ngIf="minLargePartySize !== null"
                        class="dropdown-item"
                        [ngValue]="minLargePartySize"
                    >
                        @if (availability.venue.showLargerPartiesUnreservable) {
                            Larger parties unreservable
                        } @else {
                            {{ minLargePartySize }}+
                        }
                    </option>
                </select>
            </div>
            <ng-container
                *ngIf="minLargePartySize !== null && form.get('partySize')?.value >= minLargePartySize"
            >
                <ng-container
                    *ngTemplateOutlet="largePartySizeMessage; context: { availability: availability }"
                >
                </ng-container>
            </ng-container>
            <ng-container
                *ngIf="minLargePartySize === null || form.get('partySize')?.value < minLargePartySize"
            >
                <div *ngIf="!hideDateTimeControls" class="hstack gap-2">
                    <div
                        class="d-flex flex-grow-1"
                    >
                        <input
                            #datePicker="ngbDatepicker"
                            container="body"
                            class="form-control p-0 m-0 border-0"
                            formControlName="date"
                            ngbDatepicker
                            style="width: 0; height: 0"
                            navigation="arrows"
                            placement="bottom-left"
                            [minDate]="earliestDate"
                            [markDisabled]="isDateDisabled"
                            [disabled]="bookingDetails?.isDateRestricted ?? false"
                            (navigate)="onDatepickerNavigate($event)"
                        />
                        <button
                            class="btn btn-outline-secondary dropdown-toggle flex-grow-1"
                            data-testid="date-select"
                            [disabled]="bookingDetails?.isDateRestricted ?? false"
                            (click)="datePicker.toggle()"
                        >
                            <div class="calendar"></div>
                            {{ form.get('date')?.value | ngbDate | relativeDate: 'mediumDate' }}
                        </button>
                    </div>
                    <div class="position-relative btn-group dropdown flex-grow-1">
                        <button
                            class="btn btn-outline-secondary dropdown-toggle flex-grow-1"
                            (click)="idealTimeSelect.click()"
                        >
                            <div class="clock"></div>
                            {{ form.get('idealTime')?.value | date: 'shortTime' }}
                        </button>
                        <select
                            #idealTimeSelect
                            class="form-select btn opacity-0 position-absolute top-0 start-0 w-100 h-100"
                            formControlName="idealTime"
                            data-testid="ideal-time-select"
                            [compareWith]="Helper.areDatesEqual"
                        >
                            <option
                                *ngFor="let time of availability.intervalIdealTimes"
                                [ngValue]="time"
                            >
                                {{ time | date: 'shortTime' }}
                            </option>
                        </select>
                    </div>
                </div>
            </ng-container>
        </div>
        <div
            *ngIf="minLargePartySize === null || form.get('partySize')?.value < minLargePartySize"
            class="vstack justify-content-end"
        >
            <button
                class="btn btn-primary"
                type="button"
                data-testid="check-availability"
                (click)="checkAvailabilitySelected()"
            >
                {{ hideDateTimeControls && preselectedEventId ? 'Book Event' : 'Check Availability' }}
            </button>
        </div>
    </ng-container>
</ng-template>

<ng-template
    #dateRestrictedMessage
>
    <div>
        Some details of this booking cannot be changed due to card details being required.
    </div>
</ng-template>

<ng-template
    #selectRestrictions
    [formGroup]="form"
>
    <div class="hstack justify-content-between">
        <h5 class="fw-semibold m-0 px-3">
            Tell us about your booking
        </h5>
        <button
            *ngIf="bookingDetails"
            class="btn btn-close btn-block"
            type="button"
            (click)="reset()"
        >
        </button>
    </div>
    <app-accessibility-form
        [venue]="availability?.venue ?? null"
        [isLoading]="!availability"
        (restrictionsSelected)="restrictionsSelected()"
    >
    </app-accessibility-form>
</ng-template>

<ng-template
    #selectBookingType
    [formGroup]="form"
    let-availability="availability"
>
    <div class="vstack flex-grow-0">
        <div class="hstack justify-content-between">
            <h5 class="fw-semibold m-0 px-3">
                Booking Type
            </h5>
        </div>
    </div>
    <div class="vstack gap-2">
        <div class="vstack gap-2 px-2">
            <ng-container
                *ngIf="availability.hasReservableStandardBookingOptions()"
            >
                <hr class="m-0 border-secondary-subtle">
                <div class="d-flex flex-column flex-sm-row gap-2 align-items-baseline align-content-sm-stretch">
                    <div class="flex-grow-1">
                        <span class="fw-semibold">
                            Standard Booking
                        </span>
                    </div>
                    <button
                        class="btn btn-outline-secondary"
                        (click)="normalBookingTypeSelected(availability)"
                    >
                        Select
                    </button>
                </div>
            </ng-container>
            <ng-container
                *ngFor="let event of availability.availableEvents()"
            >
                <hr class="m-0 border-secondary-subtle">
                <ng-container
                    *ngTemplateOutlet="eventOption; context: {
                        event: event,
                        availability: availability,
                        canSelect: true,
                    }"
                >
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template
    #explainNonReservableEventBooking
    [formGroup]="form"
    let-availability="availability"
>
    <div class="vstack flex-grow-0">
        <div class="hstack justify-content-between">
            <h5 class="fw-semibold m-0 px-3">
                Book {{ form.get('selectedEventId')?.value | eventName : availability.venue }}
            </h5>
        </div>
    </div>
    <div class="vstack gap-2">
        <div class="vstack gap-2 px-2">
            <quill-view
                [content]="availability.notReservableOnlineMessage(this.form.get('selectedEventId')?.value)"
            >
            </quill-view>
        </div>
    </div>
</ng-template>

<ng-template
    #selectReason
    [formGroup]="form"
    let-availability="availability"
>
    <app-reason-selection
        [availability]="availability"
        [form]="form"
        [isLoading]="false"
        (reasonSelected)="reasonSelected($event, availability)"
        (joinWaitlistRequested)="joinWaitlistStep()"
    >
    </app-reason-selection>
</ng-template>

<ng-template
    #selectDuration
    [formGroup]="form"
    let-availability="availability"
>
    <app-duration-options
        [availability]="availability"
        [form]="form"
        [isLoading]="false"
        (durationSelected)="reasonSelected($event, availability)"
    >
    </app-duration-options>
</ng-template>

<ng-template
    #selectArea
    [formGroup]="form"
    let-availability="availability"
>
    <app-area-selection
        [availability]="availability"
        [form]="form"
        [isLoading]="false"
        (areaSelected)="areaSelected($event)"
        (joinWaitlistRequested)="joinWaitlistStep()"
    >
    </app-area-selection>
</ng-template>

<ng-template
    #selectTime
    [formGroup]="form"
    let-areaId="areaId"
    let-reasonId="reasonId"
    let-eventId="eventId"
    let-partySize="partySize"
    let-idealTime="idealTime"
    let-availability="availability"
    let-useAnyReasonAvailability="useAnyReasonAvailability"
>
    <div class="hstack justify-content-between">
        <div class="px-3 vstack gap-2">
            <h5 class="fw-semibold m-0">
                Time
            </h5>
            <ng-container
                *ngIf="availability.venue.shortPreBookingWindowMessage && availability.hasBookingSlotsInsideCutOffTimeForAreaId(areaId)"
            >
                <span [innerHTML]="availability.venue.shortPreBookingWindowMessage"></span>
            </ng-container>
            <ng-container
                *ngIf="!availability.venue.shortPreBookingWindowMessage && availability.smallestActivePreBookingWindow(areaId); let preBookingWindow"
            >
                <label
                    *ngIf="availability.hasBookingSlotsInsideCutOffTimeForAreaId(areaId)"
                    class="small text-secondary fw-semibold">
                    To book less than {{ preBookingWindow | duration : DurationUnit.Minute }} in advance,
                    please get in touch at
                    <a [href]="'tel:' + availability.venue.phoneNumber">
                        {{ availability.venue.phoneNumber }}
                    </a>
                    <ng-container *ngIf="availability.venue.emailAddress; let emailAddress">
                        or <a [href]="'mailto:' + emailAddress">{{ emailAddress }}</a>
                    </ng-container>.
                </label>
            </ng-container>
        </div>
        <button
            *ngIf="bookingDetails"
            class="btn btn-close btn-block"
            type="button"
            (click)="reset()"
        >
        </button>
    </div>
    <app-booking-slot-selection
        style="display: contents;"
        [areaId]="areaId"
        [reasonId]="reasonId"
        [eventId]="eventId"
        [partySize]="partySize"
        [idealTime]="idealTime"
        [availability]="availability"
        [useAnyReasonAvailability]="useAnyReasonAvailability"
        (waitlistTimeSelected)="joinWaitlistStep($event)"
    >
    </app-booking-slot-selection>
</ng-template>

<ng-template
    #largePartySizeMessage
    let-availability="availability"
>
    <ng-container *ngIf="availability.venue.enquiriesEnabled">
        <app-enquiry-form
            [venue]="availability.venue"
            [partySize]="form.get('partySize')?.value"
            [selectedDate]="form.get('date')?.value"
            [selectedTime]="form.get('idealTime')?.value"
            (enquirySubmitted)="onEnquirySubmitted()"
        >
        </app-enquiry-form>
    </ng-container>
    <ng-container *ngIf="!availability.venue.enquiriesEnabled">
        <div class="text-center fw-semibold p-3">
            <ng-container
                *ngIf="availability.venue.largePartyMessage"
            >
                <span [innerHTML]="availability.venue.largePartyMessage"></span>
            </ng-container>
            <ng-container
                *ngIf="!availability.venue.largePartyMessage"
            >
                To ensure the best possible experience, we ask that you get in touch at
                <a [href]="availability.venue.phoneNumber"> {{ availability.venue.phoneNumber }}</a>
                <ng-container
                    *ngIf="availability.venue.emailAddress"
                >
                    or
                    <a [href]="'mailto:' + availability.venue.emailAddress"> {{ availability.venue.emailAddress }}</a>
                </ng-container>
                to make your booking.
                <br/>
                We look forward to seeing you soon.
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<ng-template
    #eventOption
    let-event="event"
    let-availability="availability"
    let-canSelect="canSelect"
>
    <app-event-card
        [event]="event"
        [currencyCode]="availability.venue.currencyCode"
        [canSelect]="canSelect"
        [venueId]="availability.venue.id"
        (eventSelected)="eventSelected(event, availability)"
    >
    </app-event-card>
</ng-template>
